import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { OnboardingUserService } from '@/services/OnboardingUserServices';
import { ICursorElements } from '@/store/types/search.types';

import { IFilterOnboardingUser, IOnboardingUser } from '@/store/models/onboarding-user.model';
import { TAppError } from '@/store/types/base.state';
import {
  TOnboardingUserAction,
  OnboardingUserActionTypes,
  TOnboardingUserState,
} from '@/store/types/onboarding-user.types';

export const fetchOnboardingUsers = (
  filter: IFilterOnboardingUser,
): ThunkAction<Promise<void>, TOnboardingUserState, {}, TOnboardingUserAction> => {
  const request = (): TOnboardingUserAction => ({
    type: OnboardingUserActionTypes.FETCH_ONBOARDING_USERS,
    onboardingUserType: filter.type,
  });

  const fail = (error: TAppError): TOnboardingUserAction => ({
    type: OnboardingUserActionTypes.FETCH_ONBOARDING_USERS_FAIL,
    onboardingUserType: filter.type,
    error,
    documentation: 'https://docs.treezor.com/guide/users/introduction.html#list-complete-vs-unfinished-onboardings',
  });

  const success = (
    paginateOnboardingUsers?: ICursorElements<IOnboardingUser>,
    isClear?: boolean,
  ): TOnboardingUserAction => ({
    type: OnboardingUserActionTypes.FETCH_ONBOARDING_USERS_SUCCESS,
    onboardingUserType: filter.type,
    paginateOnboardingUsers,
    isClear,
    shouldSkipToaster: true,
  });

  return async (dispatch: ThunkDispatch<TOnboardingUserState, {}, TOnboardingUserAction>): Promise<void> => {
    dispatch(request());
    try {
      const paginateOnboardingUsers = await OnboardingUserService.fetchOnboardingUsers(filter);
      dispatch(success(paginateOnboardingUsers, !filter.cursor));
    } catch (error) {
      dispatch(fail(error));
    }
  };
};
